import React from "react";
import {
    Divider,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Icon,
    List,
    ListContent,
    ListHeader,
    ListItem,
    ListList,
    Menu,
    MenuItem
} from "semantic-ui-react";
import {
    SurveyFormAnswerModel,
    SurveyFormChoice,
    SurveyFormEditorNodeType,
    SurveyFormNode,
    SurveyFormQuestionModel,
    SurveyFormQuestionType,
    SurveyFormQuestionTypeNames,
} from "../../model/SurveyFormModel";

interface Props {
    questions: SurveyFormQuestionModel[],
    selected?: SurveyFormNode,
    onSelectedNodeChanged?: (node: SurveyFormNode | undefined) => void;

    onAddQuestionClick?(type: SurveyFormQuestionType): void

    onAddAnswerClick?(choice: SurveyFormChoice): void

    onDeleteSelectedClick?(): void,

    onUpSelectedClick?(): void,

    onDownSelectedClick?(): void,

    readonly?: boolean
}

const SurveyFormEditorNavigator = (props: Props) => {

    function hasAnswerChoiceValue(question: SurveyFormQuestionModel, value: string): boolean {
        if (question.answers) {
            return !!question.answers!.find((x) => x.choice.value == value);
        }
        return false;
    }

    const getAllowedAnswerChoices = (): SurveyFormChoice[] => {
        var result: SurveyFormChoice[] = [];
        if (props.selected?.question) {
            if (props.selected?.question.type == SurveyFormQuestionType.bool) {
                if (!hasAnswerChoiceValue(props.selected!.question!, "true"))
                    result.push({value: "true", displayText: "ДА"});
                if (!hasAnswerChoiceValue(props.selected!.question!, "false"))
                    result.push({value: "false", displayText: "НЕТ"});
            }
            if (props.selected?.question.type == SurveyFormQuestionType.choice) {
                props.selected?.question.choices?.forEach((choice) => {
                    if (!hasAnswerChoiceValue(props.selected!.question!, choice.value ?? ""))
                        result.push(choice);
                })
                return result;
            }
        }
        return result;
    }

    const allowedAnswerChoices = getAllowedAnswerChoices();

    return (
        <div>
            {!props.readonly && <><Menu secondary>
                <Dropdown item icon={<Icon color={"blue"} name={"plus"}/>}>
                    <DropdownMenu>
                        {SurveyFormQuestionTypeNames.map((x) =>
                            <DropdownItem text={x.name}
                                          key={x.type}
                                          onClick={() => {
                                              if (props.onAddQuestionClick)
                                                  props.onAddQuestionClick!(x.type);
                                          }}/>)}
                    </DropdownMenu>
                </Dropdown>
                {allowedAnswerChoices.length > 0 &&
                    <Dropdown item text='Добавить ответ'>
                        <DropdownMenu>
                            {allowedAnswerChoices.map((x) =>
                                <DropdownItem text={x.displayText}
                                              key={x.value}
                                              onClick={() => {
                                                  if (props.onAddAnswerClick)
                                                      props.onAddAnswerClick!(x);
                                              }}/>)}
                        </DropdownMenu>
                    </Dropdown>}
                <MenuItem
                    icon={<Icon color={props.selected ? "red" : "grey"} name={"minus"}/>}
                    disabled={!props.selected}
                    onClick={() => {
                        if (props.onDeleteSelectedClick)
                            props.onDeleteSelectedClick!();
                    }}
                />
                <MenuItem
                    icon={<Icon color={props.selected ? "blue" : "grey"} name={"arrow up"}/>}
                    disabled={!props.selected}
                    onClick={() => {
                        if (props.onUpSelectedClick)
                            props.onUpSelectedClick!();
                    }}
                />
                <MenuItem
                    icon={<Icon color={props.selected ? "blue" : "grey"} name={"arrow down"}/>}
                    disabled={!props.selected}
                    onClick={() => {
                        if (props.onDownSelectedClick)
                            props.onDownSelectedClick!();
                    }}
                />
            </Menu><Divider/></>}
            <List>
                {props.questions.map((question, index) =>
                    SurveyFormEditorNavigatorQuestionNode({
                        question: question,
                        selected: props.selected,
                        index: index,
                        onSelectedNodeChanged: props.onSelectedNodeChanged
                    }))
                }
            </List>
        </div>);
}

// ====================================================================================

interface SurveyFormEditorNavigatorQuestionNodeProps {
    question: SurveyFormQuestionModel,
    parentIndex?: string,
    index: number,
    selected?: SurveyFormNode,
    onSelectedNodeChanged?: (node: SurveyFormNode | undefined) => void;
}

const SurveyFormEditorNavigatorQuestionNode = (props: SurveyFormEditorNavigatorQuestionNodeProps) => {
    const isSelected = props.selected?.question == props.question;
    return (
        <ListItem style={{backgroundColor: isSelected ? "lightyellow" : "white"}} key={props.question.id}>
            <ListContent>
                <ListHeader
                    style={{
                        "cursor": "pointer", "fontWeight": isSelected ? "bold" : "normal",
                    }}
                    onClick={() => {
                        if (props.onSelectedNodeChanged)
                            props.onSelectedNodeChanged(
                                props.selected?.question != props.question ?
                                    {
                                        type: SurveyFormEditorNodeType.question,
                                        question: props.question
                                    } : undefined);
                    }}>
                    {/*{isSelected && <List.Icon><Icon name="arrow right"/></List.Icon>}*/}
                    {props.parentIndex}{props.index + 1}. {props.question.questionDisplayText}
                </ListHeader>

                {props.question.answers && props.question.answers.length > 0 &&
                    <ListList style={{"marginLeft": "16px"}}>
                        {props.question.answers?.map((answer, index) =>
                            SurveyFormEditorNavigatorAnswerNode({
                                answer: answer,
                                selected: props.selected,
                                index: index,
                                parentIndex: (props.parentIndex ?? "") + (props.index + 1) + ".",
                                onSelectedNodeChanged: props.onSelectedNodeChanged
                            }))}
                    </ListList>
                }
            </ListContent>
        </ListItem>);
}

interface SurveyFormEditorNavigatorAnswerNodeProps {
    answer: SurveyFormAnswerModel,
    selected?: SurveyFormNode,
    index: number,
    parentIndex?: string,
    onSelectedNodeChanged?: (node: SurveyFormNode | undefined) => void;
}

const SurveyFormEditorNavigatorAnswerNode = (props: SurveyFormEditorNavigatorAnswerNodeProps) => {
    const isAnswerSelected = props.selected?.answer == props.answer;
    return (
        <ListItem style={{backgroundColor: isAnswerSelected ? "lightyellow" : "white"}}>
            <ListContent>
                <ListHeader style={{
                    "cursor": "pointer",
                    "fontSize": "14px",
                    "fontStyle": "italic",
                    "fontWeight": isAnswerSelected ? "bold" : "normal",
                }} onClick={() => {
                    if (props.onSelectedNodeChanged)
                        props.onSelectedNodeChanged(
                            props.selected?.answer != props.answer ?
                                {answer: props.answer, type: SurveyFormEditorNodeType.answer} : undefined);
                }}>
                    {isAnswerSelected && <List.Icon><Icon name="arrow right"/></List.Icon>}
                    если - {props.answer.choice.displayText}
                </ListHeader>
                {props.answer.questions && props.answer.questions.length > 0 &&
                    <ListList style={{"marginLeft": "16px"}}>
                        {props.answer.questions.map((question, index) =>
                            SurveyFormEditorNavigatorQuestionNode({
                                question: question,
                                selected: props.selected,
                                index: index,
                                parentIndex: (props.parentIndex ?? "") + (props.index + 1) + ".",
                                onSelectedNodeChanged: props.onSelectedNodeChanged
                            }))
                        }
                    </ListList>}
            </ListContent>
        </ListItem>);
}

// ====================================================================================

export default SurveyFormEditorNavigator;